import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlSigninOtpCss = baseCss;

const NlSigninOtpStyle0 = nlSigninOtpCss;

const NlSigninOtp = /*@__PURE__*/ proxyCustomElement(class NlSigninOtp extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlLoginOTPUser = createEvent(this, "nlLoginOTPUser", 7);
        this.nlLoginOTPCode = createEvent(this, "nlLoginOTPCode", 7);
        this.nlCheckLogin = createEvent(this, "nlCheckLogin", 7);
        this.titleLogin = 'Log in with DM';
        this.description = 'Please enter your user name or npub, and we will send you a direct message with a one-time code.';
        this.titleLoginOTP = 'Enter the code';
        this.descriptionOTP = 'Please enter the one-time code we sent to you as a direct message on Nostr.';
        this.isGood = false;
    }
    handleInputChange(event) {
        if (!state.isOTP) {
            state.nlSigninOTP.loginName = event.target.value;
            this.nlCheckLogin.emit(state.nlSigninOTP.loginName);
        }
        else {
            state.nlSigninOTP.code = event.target.value;
        }
    }
    handleLogin(e) {
        e.preventDefault();
        if (state.isOTP)
            this.nlLoginOTPCode.emit(state.nlSigninOTP.code);
        else
            this.nlLoginOTPUser.emit(state.nlSigninOTP.loginName);
    }
    render() {
        return (h(Fragment, { key: '908b593238b5fa1b577cee0a8149e013a2cd4e81' }, h("div", { key: '2d57c60631a906fc566d5f1f76cdac11773436c5', class: "p-4 overflow-y-auto" }, h("h1", { key: 'b08c82e952dbc3af15e25c48f318677a68f46d19', class: "nl-title font-bold text-center text-2xl" }, state.isOTP ? this.titleLoginOTP : this.titleLogin), h("p", { key: '64f6ec549cd2fc9c4b3672c5463d183d9626c20b', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, state.isOTP ? this.descriptionOTP : this.description)), h("div", { key: '5e9bf1ba4a6a72788f605ef44f98cdafeb67e0d0', class: "max-w-72 mx-auto" }, h("div", { key: '3986a554e56c5457abf19162ecdafe0cc72ceade', class: "relative mb-2" }, h("input", { key: '139d115f54a0253fac37eb6bbbba5f00cec6e3b6', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: state.isOTP ? 'code from direct message' : 'npub or name@domain', value: state.isOTP ? state.nlSigninOTP.code : state.nlSigninOTP.loginName }), h("div", { key: 'bae2734dbce11c6c9a9f59b2ba1a57841213e8f0', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: '8dc6fc177553d183873eae6c4ef31509d45c5784', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: this.isGood ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: 'dd9d07329ee6ae0491c009adffc673cf6a4103d3', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" }), h("path", { key: '0357daa2fb59eb3c2cbaf62e49d69e42dde16b85', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })))), h("div", { key: '91a36d9e0420b28eca1edcd1ec8759c25b2d51b3', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: 'e462b623f95c800d1589d3eef07d2216b70bdd64', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: 'c6b89e573097ac7d40c0648a2e87222d48e72b40', titleBtn: "Log in", disabled: state.isLoading, onClick: e => this.handleLogin(e) }, state.isLoading && (h("span", { key: '0be64571f00987f716e986af9cb043e3eb22b796', slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" }))))));
    }
    static get style() { return NlSigninOtpStyle0; }
}, [0, "nl-signin-otp", {
        "titleLogin": [1, "title-login"],
        "description": [1],
        "titleLoginOTP": [1, "title-login-o-t-p"],
        "descriptionOTP": [1, "description-o-t-p"],
        "isGood": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-signin-otp", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-signin-otp":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSigninOtp);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlSigninOtp as N, defineCustomElement as d };

//# sourceMappingURL=nl-signin-otp2.js.map